import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { footerColorsKeys } from 'src/editor/layout/sidebar/website-styles-settings/consts'
import { useCurrentTheme } from 'src/editor/layout/sidebar/website-styles-settings/hooks/useCurrentTheme'
import { WebsiteFooterInterface } from 'src/shared/types/website-entities'
import { ContentWidthControl } from './controls/content-width-control'
import { ImageControl } from './controls/image-control'
import { PaddingControl } from './controls/padding-control'
import { ColorPickerGroup } from './groups/color-picker'
import { EntityBorderGroup } from './wrappers/border-groups/entity-border-group'

export interface WebsiteFooterSettingsProps {
  entity: WebsiteFooterInterface
}

export const WebsiteFooterSettings = ({
  entity,
}: WebsiteFooterSettingsProps) => {
  const { t } = useTranslation()
  const updateProp = useUpdateProp(entity)
  const { currentTheme, onUpdate } = useCurrentTheme()

  return (
    <>
      <GroupTitle className="mb-6" withoutHorizontalLine>
        {t('website_styles_settings.colors.label')}
      </GroupTitle>
      <ColorPickerGroup
        colorKeys={footerColorsKeys}
        elementKey="headerAndFooter"
        labelClassName="basis-auto"
        singleDeviceMode
      />
      <ImageControl
        label="website_theme_settings.group.footer.background_picture"
        labelClassName="basis-auto"
        fileId={currentTheme.headerAndFooter.footerBackgroundPicture.file?.id}
        updateBackgroundFile={file =>
          onUpdate({
            headerAndFooter: {
              ...currentTheme?.headerAndFooter,
              footerBackgroundPicture: {
                ...currentTheme.headerAndFooter.footerBackgroundPicture,
                fileId: file?.id,
                file,
              },
            },
          })
        }
        update={background => {
          onUpdate({
            headerAndFooter: {
              ...currentTheme?.headerAndFooter,
              footerBackgroundPicture: {
                ...currentTheme.headerAndFooter.footerBackgroundPicture,
                background,
              },
            },
          })
        }}
        backgroundPosition={
          currentTheme.headerAndFooter.footerBackgroundPicture.background
        }
      />
      <EntityBorderGroup
        entity={entity}
        propertyKey="border"
        mobilePropertyKey="mobileBorder"
      />
      <GroupTitle className="mb-6" isFirst>
        {t('settings_styles.size_and_position.label')}
      </GroupTitle>
      <ContentWidthControl
        contentWidth={entity.contentWidth}
        update={updateProp('contentWidth')}
      />
      <GroupTitle className="mb-6" isFirst>
        {t('settings_styles.padding.label')}
      </GroupTitle>
      <PaddingControl
        padding={entity?.padding}
        mobilePadding={entity?.mobilePadding}
        update={updateProp('padding')}
        mobileUpdate={updateProp('mobilePadding')}
        label="settings_styles.padding.top"
        propertyKey="paddingTop"
      />
      <PaddingControl
        padding={entity?.padding}
        mobilePadding={entity?.mobilePadding}
        update={updateProp('padding')}
        mobileUpdate={updateProp('mobilePadding')}
        label="settings_styles.padding.bottom"
        propertyKey="paddingBottom"
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
